import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const CloseIcon1: React.FC<NormalIconProps> = (props) => (
	<svg viewBox="0 0 18 18" fill="none" onClick={props.onClick} className={props.className ? props.className : ''}>
		<path d="M1 1L17 17" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M17 1L1 17" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);
